import { COLORS } from './ui'

// Reordered for the foundation-model era: learn the tooling, then build, then
// stand on pretrained models rather than training everything from scratch.
const LEVELS = [
  { n: 1, label: 'Python + NumPy', sub: 'arrays · vectorised math', color: '#818cf8' },
  { n: 2, label: 'PyTorch', sub: 'tensors · autograd · training loops', color: '#a78bfa' },
  { n: 3, label: 'Image fundamentals', sub: 'OpenCV · colour · filters', color: '#c084fc' },
  { n: 4, label: 'CNNs', sub: 'convolution · pooling · backprop', color: '#e879f9' },
  { n: 5, label: 'Transfer learning', sub: 'timm · 🤗 · fine-tuning / LoRA', color: '#f472b6' },
  { n: 6, label: 'Detection & Segmentation', sub: 'YOLO · DETR · SAM 2', color: '#fb7185' },
  { n: 7, label: 'Vision Transformers', sub: 'ViT · attention · DINOv2', color: '#fb923c' },
  { n: 8, label: 'Multimodal & VLMs', sub: 'CLIP · LLaVA · GPT-4o', color: '#fbbf24' },
  { n: 9, label: 'Generative', sub: 'diffusion · 3D · video', color: '#fde047' },
]

export function Roadmap2D() {
  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto',
      alignItems: 'center', justifyContent: 'center', gap: 6, padding: '78px 24px 92px',
      fontFamily: "'General Sans', system-ui, sans-serif", textAlign: 'center', color: COLORS.text,
    }}>
      <div style={{ fontSize: 'clamp(22px,3vw,32px)', fontWeight: 800 }}>Learning Roadmap</div>
      <div style={{ fontSize: 11.5, letterSpacing: '0.1em', color: COLORS.textFaint, fontFamily: "'JetBrains Mono', ui-monospace, monospace", marginBottom: 12 }}>
        START WITH PYTHON · END WITH GENERATIVE & MULTIMODAL
      </div>

      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 7, width: '100%', maxWidth: 460 }}>
        {/* spine */}
        <div style={{ position: 'absolute', left: 17, top: 6, bottom: 6, width: 2, background: 'linear-gradient(#818cf8, #fde047)', opacity: 0.4 }} />
        {LEVELS.map(l => (
          <div key={l.n} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{
              flexShrink: 0, width: 36, height: 36, borderRadius: '50%', display: 'grid', placeItems: 'center',
              background: `${l.color}22`, border: `2px solid ${l.color}`, color: l.color, fontWeight: 800, fontSize: 14,
              boxShadow: `0 0 14px ${l.color}55`, zIndex: 1,
            }}>{l.n}</div>
            <div style={{
              flex: 1, textAlign: 'left', background: 'rgba(10,10,26,0.5)', border: `1px solid ${l.color}33`,
              borderRadius: 10, padding: '8px 14px', backdropFilter: 'blur(6px)',
            }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: l.color }}>{l.label}</div>
              <div style={{ fontSize: 12.5, color: COLORS.textDim, fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}>{l.sub}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ fontSize: 14.5, color: COLORS.amber, marginTop: 14 }}>🚀 Today you’d lean on pretrained foundation models, not train from zero.</div>
    </div>
  )
}
